import React, { useEffect, useState } from 'react';
import Swal2 from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import DatePopUp from './date_popup.js';
import TaskPopUp from './task_popup.js';
import '../styles/history_popup.css';


const MySwal = withReactContent(Swal2);

const NewPopUp = (props) => {
    const [tasks, setTasks] = useState([]);
    const [hearings, setHearings] = useState([]);
    const [showDate, setShowDate] = useState(false);
    const [dateId, setDateId] = useState('');
    const [showTask, setShowTask] = useState(false);
    const [taskId, setTaskId] = useState('');
    
    const closeDatePopUp = (e) => {
        setShowDate(!showDate);
        setDateId('');
    }

    const showDatePopUp = (e) => {
        setDateId(e.target.value);
        setShowDate(true);
        setShowTask(false);
    }

    const closeTaskPopUp = (e) => {
        setShowTask(!showTask);
    }

    const showTaskPopUp = (e) => {
        setTaskId(e.target.value);
        setShowTask(true);
        setShowDate(false);
    }

    useEffect(() => {

        var hearingMain = props.team === 1 ? props.hearingsData : props.hearingsTeam2Data;
        var hearingSheetMain = props.team === 1 ? props.hearingsSheetData : props.hearingsTeam2SheetData;
        var taskMain = props.team === 1 ? props.tasksData : props.tasksTeam2Data;
        var tasksSheetMain = props.team === 1 ? props.tasksSheetData : props.tasksTeam2SheetData;
        var archDateMain = props.team === 1 ? props.archDate : props.archDateTeam2;
        var archTasksMain = props.team === 1 ? props.archTasks : props.archTasksTeam2;

        var tasksArr = taskMain.filter(el => el.readed === 'no' && el.responsible === props.user.name);
        setTasks(tasksArr);

        var hearingsArr = hearingMain.filter(el => el.readed === 'no' && el.lawyer === props.user.name);
        setHearings(hearingsArr);
        
    },[]);
   
    return(
        <>
            {showDate ? 
            <>
                <DatePopUp 
                    dateID = {dateId}
                    hearingsData = {props.hearingsData}
                    hearingsSheetData = {props.hearingsSheetData}
                    tasksData = {props.tasksData}
                    tasksSheetData = {props.tasksSheetData}
                    closeDatePopUp = {closeDatePopUp}
                    lawyersData = {props.lawyersData}
                    refreshData = {props.refreshData}
                    user = {props.user}
                    courtsData = {props.courtsData}
                    banksData = {props.banksData}
                    usersData = {props.usersData}
                    resultsData = {props.resultsData}
                    tasksTypesData = {props.tasksTypesData}
                    history = {true}
                    checkPermissions = {props.checkPermissions}
                    team = {props.team}
                    hearingsTeam2Data = {props.hearingsTeam2Data}
                    hearingsTeam2SheetData = {props.hearingsTeam2SheetData}
                    tasksTeam2Data = {props.tasksTeam2Data}
                    tasksTeam2SheetData = {props.tasksTeam2SheetData}
                    archDateTeam2 = {props.archDateTeam2}
                    archDate = {props.archDate}
                />
            </>
            : ''}
            {showTask ? 
            <>
                <TaskPopUp 
                    taskID = {taskId}
                    hearingsData = {props.hearingsData}
                    tasksData = {props.tasksData}
                    tasksSheetData = {props.tasksSheetData}
                    closeTaskPopUp = {closeTaskPopUp}
                    lawyersData = {props.lawyersData}
                    refreshData = {props.refreshData}
                    user = {props.user}
                    courtsData = {props.courtsData}
                    banksData = {props.banksData}
                    usersData = {props.usersData}
                    resultsData = {props.resultsData}
                    tasksTypesData = {props.tasksTypesData}
                    history = {true}
                    checkPermissions = {props.checkPermissions}
                    team = {props.team}
                    hearingsTeam2Data = {props.hearingsTeam2Data}
                    hearingsTeam2SheetData = {props.hearingsTeam2SheetData}
                    tasksTeam2Data = {props.tasksTeam2Data}
                    tasksTeam2SheetData = {props.tasksTeam2SheetData}
                    archTasksTeam2 = {props.archTasksTeam2}
                    archTasks= {props.archTasks}
                 />
            </>
            : ''}
            {showDate || showTask ? '' : 
            <div className="mainContainerNewPopUp">
                <div className="closeBox">
                    <button className="closeClientButton" onClick={props.close}>X</button> 
                    </div>
                <div className="hearingTitle">
                    Nowe rekordy
                </div>
                <div className="hearings_history_box">
                    <div className="hearings_history_title">
                        ROZPRAWY
                    </div>
                    <div className="hearings_data_box">
                        <div id="hearings_data_header" className="hearings_data_box_row">
                            <div className="hearings_data_box_col">
                                Data rozprawy
                            </div>
                            <div className="hearings_data_box_col">
                                Bank
                            </div>
                            <div className="hearings_data_box_col">
                                Sygnatura
                            </div>
                            <div className="hearings_data_box_col">
                                Temat
                            </div>
                            <div className="hearings_data_box_col">
                                
                            </div>
                        </div>
                        {hearings.map(el => (
                            <>
                                <div className="hearings_data_box_row">
                                    <div className="hearings_data_box_col">
                                        {el.date}
                                    </div>
                                    <div className="hearings_data_box_col">
                                        {el.bank}
                                    </div>
                                    <div className="hearings_data_box_col">
                                        {el.sygn}
                                    </div>
                                    <div className="hearings_data_box_col">
                                        {el.subject}
                                    </div>
                                    <div className="hearings_data_box_col">
                                        {true ? '' : <button className="viewButton" value={el.id} onClick={showDatePopUp}>PRZEJDŹ</button>}
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                    
                </div>
                <div className="hearings_history_box">
                    <div className="hearings_history_title">
                        ZADANIA
                    </div>
                    <div className="hearings_data_box">
                        <div id="hearings_data_header" className="hearings_data_box_row">
                            <div className="hearings_data_box_col">
                                Data startowa
                            </div>
                            <div className="hearings_data_box_col">
                                Termin wykonania
                            </div>
                            <div className="hearings_data_box_col">
                                Zadanie
                            </div>
                            <div className="hearings_data_box_col">
                                Osoba odpowiedzialna
                            </div>
                            <div className="hearings_data_box_col">
                                
                            </div>
                        </div>
                        {tasks.map(el => (
                            <>
                                <div className="hearings_data_box_row">
                                    <div className="hearings_data_box_col">
                                        {el.start_date}
                                    </div>
                                    <div className="hearings_data_box_col">
                                        {el.final_date}
                                    </div>
                                    <div className="hearings_data_box_col">
                                        {el.task}
                                    </div>
                                    <div className="hearings_data_box_col">
                                        {el.responsible}
                                    </div>
                                    <div className="hearings_data_box_col">
                                        {true ? '' : <button className="viewButton" value={el.id} onClick={showTaskPopUp}>PRZEJDŹ</button>}
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                    
                </div>
            </div>
            }
        </>
    )

}

export default NewPopUp;